import { Flex, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react'
import { TbDotsVertical } from 'react-icons/tb'
import type { Child } from '../../api/user/family/Children'

interface ChildRowProps {
  child: Child
  onEdit: (id: string) => void
  onArchive: (child: Child) => void
}

// List row for the "My Family" screen. Renders the child's display name ONLY —
// the birth date and any derived years-old value are deliberately kept off this
// surface (D-10 / FAM-06 privacy guardrail). The per-row overflow menu (mirrors
// PatternListPanel.tsx) carries exactly two items: Edit and the destructive
// Archive (#FF3B30, the only accent on the row).
const ChildRow = ({ child, onEdit, onArchive }: ChildRowProps) => {
  return (
    <Flex align="center" justify="space-between" minH="44px" w="100%">
      <Text textStyle="heavy.200" color="#171C22" noOfLines={1}>
        {child.display_name}
      </Text>

      <Menu placement="bottom-end">
        <MenuButton
          as={IconButton}
          aria-label={`Options for ${child.display_name}`}
          icon={<Icon as={TbDotsVertical} boxSize="18px" />}
          variant="ghost"
          size="sm"
          color="#7E8B9A"
          _hover={{ bg: '#F5F7F9', color: '#171C22' }}
        />
        <MenuList>
          <MenuItem onClick={() => onEdit(child.id)}>Edit</MenuItem>
          <MenuItem onClick={() => onArchive(child)} color="#FF3B30">
            Archive
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  )
}

export default ChildRow
export type { ChildRowProps }
